import React, { useEffect, useState } from "react";
import { Form, Col, Row, Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { envConfig } from "../../constants/api-endpoint";
import { COOKIE } from "../../constants/app-constant";
import { getCookie } from "../../utility/cookieProvider";
import { httpPost } from "../../utility/requestHelper";
import { BlueLock } from "../Icons/icons.component";
import { formatDate } from "../../utility/common-methods";
import { DATE_FORMATS } from "../../constants/app-constant";
const { MMDDYYYY_slash, DDMMYYYY_dash } = DATE_FORMATS;
export const UserProfile = () => {
  const [changePassword, setChangePassword] = useState(false);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const userId = getCookie(COOKIE.CONCEPT_USER_ID);
  const userEmail = getCookie(COOKIE.CONCEPT_USER_EMAIL);
  const { start_date, end_date } = selectedClient || {};

  return (
    <>
      <div className="personalDetailsWrap">
        <ChangePassword
          key={Math.random()}
          selectedClient={selectedClient}
          userId={userId}
          userEmail={userEmail}
          show={changePassword}
          handleClose={() => setChangePassword(false)}
        />
        <form>
          <div className="form-group row">
            <label className="col-sm-2">Company Name</label>
            <div className="col-sm-10 form-control-plaintext">
              {selectedClient.client_name}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2">User - ID</label>
            <div className="col-sm-10 form-control-plaintext">{userEmail}</div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2">Subscribed On</label>
            <div className="col-sm-10 form-control-plaintext">
              {start_date !== null && start_date !== "0000-00-00" && (
                <>{formatDate(new Date(start_date), DDMMYYYY_dash)}</>
              )}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2">Expiry Date</label>
            <div className="col-sm-10 form-control-plaintext">
              {end_date !== null && end_date !== "0000-00-00" && (
                <>{formatDate(new Date(end_date), DDMMYYYY_dash)}</>
              )}
            </div>
          </div>
          <div className="form-group row">
            <a
              href="#"
              className="changePasswordLink"
              onClick={() => setChangePassword(true)}
            >
              <BlueLock /> Change Password
            </a>
          </div>
        </form>
      </div>
      <div className="cmsLinkWrap">
        <a href="/terms-and-services" target="_blank">
          Terms of Service
        </a>
        <a href="/privacy-policies" target="_blank">
          Privacy Policy
        </a>
      </div>
    </>
  );
};

export const ChangePassword = ({
  show,
  handleClose,
  selectedClient,
  userEmail,
  userId,
}) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showModal, setShowModal] = useState(show);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  function changePassword() {
    if (!selectedClient || !selectedClient.id || !oldPassword || !newPassword) {
      return;
    }
    httpPost(envConfig.CHANGE_PASSWORD, {
      client_id: selectedClient.id,
      email: btoa(userEmail),
      old_password: oldPassword,
      new_password: newPassword,
      user_id: userId,
      pwd_condition: true
    })
      .then((res) => {
        if (res.data.status === 200) {
          closeModal();
        } else {
          alert(res.data.messsage || "Error while changing password");
        }
      })
      .catch((err) => {
        alert("Error while changing password");
      });
  }

  function closeModal() {
    setShowModal(false);
    if (typeof handleClose === "function") {
      handleClose();
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group as={Row} controlId="formPlaintextEmail">
            <Form.Label column sm="4">
              Email:
            </Form.Label>
            <Col sm="8">
              <Form.Control plaintext readOnly defaultValue={userEmail} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="oldPassword">
            <Form.Label column sm="4">
              Old Password:
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="password"
                value={oldPassword}
                placeholder="Old Password"
                onChange={(evt) => {
                  setOldPassword(evt.currentTarget.value.trim());
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="newPassword">
            <Form.Label column sm="4">
              New Password:
            </Form.Label>
            <Col sm="8">
              <Form.Control
                value={newPassword}
                type="password"
                placeholder="New Password"
                onChange={(evt) => {
                  setNewPassword(evt.currentTarget.value.trim());
                }}
              />
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={changePassword}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
